import AppRoutes from "./routes/AppRoutes";
import Header from "./components/common/Header";
function App() {
  return (
    <>
      <Header />
      <AppRoutes />
    </>
  );
}

export default App;


